import { render, staticRenderFns } from "./AddRoomFromHistoryPopup.vue?vue&type=template&id=2217493a&scoped=true"
import script from "./AddRoomFromHistoryPopup.vue?vue&type=script&lang=ts"
export * from "./AddRoomFromHistoryPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2217493a",
  null
  
)

export default component.exports